import { render, staticRenderFns } from "./EditLandlords.vue?vue&type=template&id=5bf39e2d&scoped=true"
import script from "./EditLandlords.vue?vue&type=script&lang=js"
export * from "./EditLandlords.vue?vue&type=script&lang=js"
import style0 from "./EditLandlords.vue?vue&type=style&index=0&id=5bf39e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf39e2d",
  null
  
)

export default component.exports